<template>
    <div class="front">
        <section id="intro">
            <div class="intro-container">
                <div id="introCarousel" class="carousel  slide carousel-fade" data-ride="carousel">

                    <ol class="carousel-indicators"></ol>

                    <div class="carousel-inner" role="listbox">
                        <template v-for="(item,index) in acceuils">
                            <transition name="fade">
                                <carousel-item
                                        :item="item"
                                        :index="index"
                                        :slide-active="slideActive"/>
                            </transition>
                        </template>
                    </div>

                    <a class="carousel-control-prev"
                       href="javascript:void(0)"
                       @click="prev"
                       role="button"
                       data-slide="prev">
                        <span class="carousel-control-prev-icon ion-chevron-left" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </a>

                    <a class="carousel-control-next"
                       href="javascript:void(0)"
                       @click="next"
                       role="button"
                       data-slide="next">
                        <span class="carousel-control-next-icon ion-chevron-right" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                    </a>

                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import {mapActions,mapState} from 'vuex'

    import CarouselItem from "../../layout/component/CarouselItem";
    export default {
        name: "index",
        components: {CarouselItem},
        data(){
            return {
                slideActive: 0
            }
        },
        computed:{
          ...mapState({
              acceuils: (state) => state.acceuil.acceuils
          })
        },
        mounted() {
           setInterval(this.next, 12000);
            this.acceuilAllAction()
        },
        methods:{
            ...mapActions('acceuil',['acceuilAllAction']),
            next(){
                if(this.slideActive >= this.acceuils.length - 1){
                    this.slideActive = 0
                }else {
                    this.slideActive++
                }
            },
            prev(){
                if(this.slideActive <= 0){
                    this.slideActive = this.acceuils.length - 1
                }else {
                    this.slideActive--
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>